import {Component, OnInit, HostListener, Inject, Input} from '@angular/core';
import {take} from 'rxjs/operators';
import {MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';

import {environment} from '@env/environment';
import {AuthenticatedUserService} from '@app/core/service/authenticated-user.service';
import {User} from '@app/core/model/user';

@Component({
    selector: 'ngc-etx-login-error-dialog',
    templateUrl: './etx-login-error-dialog.component.html',
    styleUrls: ['./etx-login-error-dialog.component.scss']
})
export class ETXLoginErrorDialogComponent implements OnInit {

    @Input() message: string;
    isSysAdmin: boolean;

    constructor(public dialogRef: MatDialogRef<ETXLoginErrorDialogComponent>,
                private authenticatedUserService: AuthenticatedUserService) {
    }

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeydownHandler(event: KeyboardEvent) {
        this.onClose();
        event.preventDefault();
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKeydownHandler(event: KeyboardEvent) {
        this.onClose();
    }

    ngOnInit() {
        this.getUser();
    }

    private getUser() {
        this.authenticatedUserService.authenticatedUser$.pipe(take(1))
            .subscribe((user: User) => {
                this.isSysAdmin = this.authenticatedUserService.isSysAdmin(user);
                ;
            });
    }

    onClose() {
        this.dialogRef.close();
    }

    redirectToSchoolPassport() {
        window.open(`${environment.etxBaseURI}/account/${this.isSysAdmin ? 'sysadm' : 'default'}/login-form`);
    }
}
